export const CREATE_TICKET_DATA = "CREATE_TICKET_DATA";
export const CREATE_TICKET_START_LOADER = "CREATE_TICKET_START_LOADER";
export const CREATE_TICKET_STOP_LOADER = "CREATE_TICKET_STOP_LOADER";
export const CREATE_TICKET_HIDE_ERROR = "CREATE_TICKET_HIDE_ERROR";
export const CREATE_TICKET_ERROR = "CREATE_TICKET_ERROR";
